import { Typography } from "@mui/material";

export default function Date({ data }) {
  return (
    <Typography color="text.main" variant="h6" textAlign="left">
      {data.date}
      <br /> {data.time}
    </Typography>
  );
}
